import { render } from "./FlaggedTransactionCorrection.vue?vue&type=template&id=013bacfd"
import script from "./FlaggedTransactionCorrection.vue?vue&type=script&lang=js"
export * from "./FlaggedTransactionCorrection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__